import { BaseHttpProvider } from "./base-http.provider"

export class DepartmentsProvider extends BaseHttpProvider {
  async getDepartments() {
    const data = await this.execute({
      uri: "/departments",
    })

    return data?.departments ?? []
  }
}
